import { ReceiptTemplateResponse, } from '@aeris/contracts';
import { request } from "./client.js";
/**
 * `/api/v1/organization/receipt-template` — o modelo da nota térmica (F149).
 *
 * Um por loja: não há lista e não há id. `PUT` manda o modelo inteiro com a
 * versão que a tela leu, e o servidor recusa se alguém salvou no meio.
 */
export const fetchReceiptTemplate = async (signal) => ReceiptTemplateResponse.parse(await request('/api/v1/organization/receipt-template', {
    ...(signal ? { signal } : {}),
}));
export const saveReceiptTemplate = async (input) => ReceiptTemplateResponse.parse(await request('/api/v1/organization/receipt-template', {
    method: 'PUT',
    body: input,
}));
//# sourceMappingURL=receipt-template.js.map